



import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true); // Start open by default
  const [userRole, setUserRole] = useState(
    localStorage.getItem("userRole") || "0"
  );
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("access_token")
  );
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = () => {
      setUserRole(localStorage.getItem("userRole") || "0");
      setIsLoggedIn(!!localStorage.getItem("access_token"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token-info");
    localStorage.removeItem("userRole");
    localStorage.removeItem("access_token");
    setUserRole("0");
    setIsLoggedIn(false);
    navigate("/");
  };

  return (
    <div
      className={`sidebar-container ${isOpen ? "sidebar-open" : "sidebar-closed"}`}
    >
      <button className="toggle-button" onClick={toggleSidebar}>
        ☰
      </button>
      <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
        <ul>
          <li>
            <Link to="/">
              <i className="fas fa-home"></i>
              <span>Home</span>
            </Link>
          </li>
          {userRole === "1" && (
            <>
              <li>
                <Link to="/manage-rooms">
                  <i className="fas fa-edit"></i>
                  <span>Manage Rooms</span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <i className="fas fa-building"></i>
                  <span>Accommodation</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/booked-reports">
                  <i className="fas fa-book"></i>
                  <span>Booked Reports</span>
                </Link>
              </li> */}
              <li>
                <Link to="/blocked-reports">
                  <i className="fas fa-ban"></i>
                  <span>Blocked Reports</span>
                </Link>
              </li>
              <li>
                <Link to="/cancelled-reports">
                  <i className="fas fa-times"></i>
                  <span>Cancelled Reports</span>
                </Link>
              </li>
            </>
          )}
          {userRole === "2" && (
            <>
              <li>
                <Link to="/manage-buildings">
                  <i className="fas fa-building"></i>
                  <span>Manage Buildings</span>
                </Link>
              </li>
            </>
          )}
          {userRole === "3" && (
            <>
              <li>
                <Link to="/manage-rooms">
                  <i className="fas fa-edit"></i>
                  <span>Manage Rooms</span>
                </Link>
              </li>
              <li>
                <Link to="/blocked-reports">
                  <i className="fas fa-ban"></i>
                  <span>Blocked Reports</span>
                </Link>
              </li>
              <li>
                <Link to="/cancelled-reports">
                  <i className="fas fa-times"></i>
                  <span>Cancelled Reports</span>
                </Link>
              </li>
            </>
          )}
          {userRole === "0" && (
            <>
              <li>
                <Link to="/">
                  <i className="fas fa-building"></i>
                  <span>Accommodation</span>
                </Link>
              </li>
            </>
          )}
          {isLoggedIn && userRole !== "3" && (
            <li>
              <Link to="/MyBookings">
                <i className="fas fa-book-reader"></i>
                <span>My Bookings</span>
              </Link>
            </li>
          )}
          <li>
            <a href="http://vmrda.gov.in/contactus.aspx" target="_blank">
              <i className="fas fa-envelope"></i>
              <span>Contact</span>
            </a>
          </li>
          {isLoggedIn ? (
            <>
              <li>
                <Link to="/profile">
                  <i className="fas fa-user"></i>
                  <span>
                    {JSON.parse(localStorage.getItem("token-info")).name}
                  </span>
                </Link>
              </li>
              <li onClick={handleLogout} className="logout-button">
                <i className="fas fa-sign-out-alt"></i>
                <span>Logout</span>
              </li>
            </>
          ) : (
            userRole !== "3" && (
              <li>
                <Link to="/Login">
                  <i className="fas fa-sign-in-alt"></i>
                  <span>Login</span>
                </Link>
              </li>
            )
          )}
        </ul>
      </div>
      {isOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </div>
  );
};

export default Sidebar;
